import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/workflows/user-workflows/{userWorkflowId}/credit-report']['GET'];

type Props = ThisApi['params'];

const getUserWorkflowCreditReport = async ({ userWorkflowId }: Props): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.get(`/workflows/user-workflows/${userWorkflowId}/credit-report`);
  return response.data;
};

export default getUserWorkflowCreditReport;
